import React, { useState } from 'react';

import Flex from 'ui/Flex/Flex';
import GeneralModal from 'components/SharedComponents/Modals/GeneralModal';
import UserGroupMembers from './UserGroupMembers';
import UserGroupNameSetter from './UserGroupNameSetter';
import { useCreateUserGroup } from 'hooks/userGroups/useCreateUserGroup';
import { useGetGroupNameHelperText } from './hooks';
import { useTranslation } from 'react-i18next';

type CreateUserGroupModalProps = {
    isOpen: boolean;
    onClose: () => void;
    existingGroupsNames: string[];
};

const CreateUserGroupModal = ({
    isOpen,
    onClose,
    existingGroupsNames,
}: CreateUserGroupModalProps): JSX.Element => {
    const { t } = useTranslation();
    const [membersEmails, setMembersEmails] = useState<string[]>([]);
    const [groupName, setGroupName] = useState('');
    const { mutate: createUserGroup } = useCreateUserGroup(
        groupName,
        membersEmails,
    );

    const onGroupNameChange = (newGroupName: string) =>
        setGroupName(newGroupName);

    const groupNameHelperText = useGetGroupNameHelperText(
        groupName,
        existingGroupsNames,
    );
    const containedButton = {
        text: t('common.confirm'),
        onClick: () => {
            createUserGroup();
            onClose();
        },
        disabled: groupNameHelperText.length > 0,
        tooltip: groupNameHelperText,
        className: 'pendo-create-group-confirm',
    };
    const textButton = {
        text: t('common.cancel'),
        onClick: onClose,
    };
    return (
        <GeneralModal
            isOpen={isOpen}
            onClose={onClose}
            title={t('adminSpace.createUserGroup.modalTitle')}
            width="lg"
            textButton={textButton}
            containedButton={containedButton}
        >
            <Flex direction="column" sx={{ gap: 2 }}>
                <UserGroupNameSetter
                    name={groupName}
                    onNameChange={onGroupNameChange}
                    helperText={groupNameHelperText}
                />
                <UserGroupMembers
                    emails={membersEmails}
                    setEmails={setMembersEmails}
                />
            </Flex>
        </GeneralModal>
    );
};

export default CreateUserGroupModal;
